<template>
  <div class="wrap">
    <div class="toolbar">
      <div class="title">用户消费排行报表</div>
      <div class="actions">
        <el-form :inline="true">
          <el-form-item label="统计日期">
            <el-date-picker
              v-model="statDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              clearable
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="loading" @click="search">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <el-main class="flex-container">
      <el-table
        :data="list"
        border
        stripe
        v-loading="loading"
        element-loading-text="加载中..."
      >
        <el-table-column type="index" label="排名" width="60" />
        <el-table-column prop="userPhone" label="用户手机号" width="150" />
        <el-table-column prop="userOrderCount" label="订单数" width="100" />
        <el-table-column prop="userConsumeAmount" label="消费总金额(元)" width="150" />
        <el-table-column prop="dt" label="统计日期" width="200" />
      </el-table>

      <div class="chart" ref="chart" />
    </el-main>

    <el-footer class="el-footer">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5, 10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </el-footer>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'UserConsumeRank',
  data() {
    return {
      loading: false,
      statDate: '',
      list: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      chart: null,
      resizeHandler: null,
    }
  },
  computed: {
    userNames() {
      // 显示手机号后四位或脱敏，这里直接显示手机号
      return (this.list || []).map(i => i.userPhone)
    },
    consumeAmounts() {
      return (this.list || []).map(i => this.toNumber(i.userConsumeAmount))
    },
  },
  mounted() {
    this.getData()
    this.resizeHandler = () => {
      if (this.chart) this.chart.resize()
    }
    window.addEventListener('resize', this.resizeHandler)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler)
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
    if (this.searchTimer) {
      clearTimeout(this.searchTimer)
      this.searchTimer = null
    }
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    search() {
      this.currentPage = 1
      this.getData()
    },
    toNumber(v) {
      const n = Number(v)
      return Number.isFinite(n) ? n : 0
    },
    getData() {
      this.loading = true
      this.$axios.get('/hadoop/userConsumeRank', {
        params: {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          dt: this.statDate || '',
        },
      })
        .then(res => {
          this.total = res.data.data.total
          this.list = res.data.data.records
          this.loading = false
          this.$nextTick(() => this.renderChart())
        })
        .catch(() => {
          this.loading = false
        })
    },
    renderChart() {
      const el = this.$refs.chart
      if (!el) return
      if (!this.chart) this.chart = echarts.init(el)

      const option = {
        title: { text: '用户消费金额排行（Top N）', left: 'center' },
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
        grid: { left: 120, right: 30, top: 80, bottom: 30 },
        xAxis: { type: 'value', name: '消费金额(元)' },
        yAxis: { type: 'category', data: this.userNames, inverse: true, name: '用户手机号' },
        series: [
          {
            name: '消费金额',
            type: 'bar',
            data: this.consumeAmounts,
            itemStyle: { color: '#E6A23C' },
            label: { show: true, position: 'right' },
          },
        ],
      }
      this.chart.setOption(option, true)
    },
  },
}
</script>

<style scoped>
.wrap {
  padding: 16px;
}
.toolbar {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}
.title {
  font-size: 18px;
  font-weight: 700;
  color: #303133;
  line-height: 32px;
}
.actions {
  display: flex;
  align-items: center;
  margin-left: 100px;
}
.chart {
  height: 1000px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  flex-shrink: 0;
  width: 800px;
}
.flex-container {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/views/UserConsumeRank.vue